import React, { PropsWithChildren } from 'react';

type TextBlockType = 'block' | 'inline';
export type TextStyleType =
  | 'display'
  | 'login'
  | 't1'
  | 't2'
  | 't3'
  | 'bb'
  | 'c1'
  | 'c2';
export type TextColorType =
  | 'point'
  | 'point4'
  | 'gray'
  | 'gray2'
  | 'black'
  | 'red'
  | 'dark'
  | 'white';

interface Props {
  textStyle?: TextStyleType;
  textColor?: TextColorType;
  style?: React.CSSProperties;
  type?: TextBlockType;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

export const Text = ({
  style,
  children,
  textStyle,
  textColor,
  type = 'block',
  className,
  onClick
}: PropsWithChildren<Props>) => {
  if (type === 'inline') {
    return (
      <span
        className={className}
        style={style}
        onClick={onClick}
        data-text-type={textStyle}
        data-text-color={textColor}
      >
        {children}
      </span>
    );
  }
  return (
    <p
      className={className}
      style={style}
      onClick={onClick}
      data-text-type={textStyle}
      data-text-color={textColor}
    >
      {children}
    </p>
  );
};
